import './SubHeader.css';

interface HeaderProps {
  children?: string;
}

function SubHeader({ children }: HeaderProps): JSX.Element {
  return <h2 className="sub-header">{children}</h2>;
}

export default SubHeader;
